import { createContext, useState, useContext, ReactNode } from 'react';

type CourseStatusContextType = {
  coursesStatus: { [courseId: string]: { isAttachmentsUploading: boolean } };
  setAttachmentsUploading: (
    courseId: string,
    isAttachmentsUploading: boolean,
  ) => void;
};

const CourseStatusContext = createContext<CourseStatusContextType>({
  coursesStatus: {},
  setAttachmentsUploading: () => {},
});

export const CourseStatusServiceProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [coursesStatus, setCoursesStatus] = useState<{
    [courseId: string]: { isAttachmentsUploading: boolean };
  }>({});

  const setAttachmentsUploading = (
    courseId: string,
    isAttachmentsUploading: boolean,
  ) => {
    setCoursesStatus(prev => ({
      ...prev,
      [courseId]: { isAttachmentsUploading },
    }));
  };

  return (
    <CourseStatusContext.Provider
      value={{ coursesStatus, setAttachmentsUploading }}
    >
      {children}
    </CourseStatusContext.Provider>
  );
};

export const useCourseStatus = () => useContext(CourseStatusContext);
